import { TFunction } from "@/types";
import * as Yup from "yup";

export const FORM_INITIAL_VALUES = {
  name: "",
  subscribe: true,
};

export const saveSearchProfileSchema = (t: TFunction) =>
  Yup.object({
    name: Yup.string()
      .min(3, t("searchProfile.errors.min"))
      .max(255, t("searchProfile.errors.max"))
      .required(t("searchProfile.errors.required")),
    subscribe: Yup.boolean().required(),
  });

export type SaveSearchProfileFormData = Yup.InferType<ReturnType<typeof saveSearchProfileSchema>>;
